module.exports = __webpack_public_path__ + "img/heart_empty.90f3dad5.svg";